export default __webpack_public_path__ + "static/media/quad.4b84ab8c.svg";